import { ButtonClassType } from '../../../../enums/buttons';
import Color from '../../../../enums/color';
import { getSimplifiedColorCode } from '../../../../helpers/color';
const ghostButtonStyle = `
  &.kpmg-button-${ButtonClassType.Ghost} {
    background: ${Color.White};
    
    &.disabled {
      border: 1px solid ${Color.Grey187};
      color: ${Color.Grey187};
      cursor: default;
    }

    &.colorTheme-${getSimplifiedColorCode(Color.MicrosoftBlue)} {
      border: 1px solid ${Color.MicrosoftBlue};
      color: ${Color.MicrosoftBlue};
    
      &:hover {
        background: ${Color.HawkesBlue};
      }
    
      &:active {
        background: ${Color.MicrosoftBlue};
        border-color: unset;
        color: ${Color.White};
      }
    }
  }
`;
export default ghostButtonStyle;
